var _ = require('underscore');
module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<p class="info-circle">\n    To ensure the best experience on our website, we recommend that you allow\n    cookies, as described in our <a href="https://about.me/legal/cookies" target="_blank"\n    rel="noopener noreferrer" class="text nowrap">Cookie Policy</a>.\n</p>\n<p class="actions">\n    <button type="button" class="button large light primary accept-cookies">Got it</button>\n</p>\n';
return __p;
};
